import { convertColumnsToOldUIReportAggregation } from '@bingads-webui-campaign/reports-v4-column-chooser';
import { shouldShowSelector, shouldShowUserScopeInput } from '../../helpers/account-selector-helper';
import { getToday, getFilteredTimeRanges, getMinimumSupportedDay } from '../date-picker/date-picker-utils';

export const getDatePickerOptions = ({ reportParam, reportSchema, i18n }) => {
  const timeGrain = convertColumnsToOldUIReportAggregation(reportParam.columns);
  const { timeZone } = reportParam;
  const today = getToday(i18n, timeZone);
  const minSupportedDay = getMinimumSupportedDay(reportSchema, timeGrain, today);
  return getFilteredTimeRanges(timeGrain, today, minSupportedDay, reportSchema, i18n).filter(item => item.key !== 'Custom');
};

export const shouldShowAccountSelect = ({ reportSchema, scope }) => {
  const isMultipleAccountSelectorShown = shouldShowSelector(reportSchema.ScopeFilterLevel, scope);
  const isUserScopeInputShown = shouldShowUserScopeInput(reportSchema.ScopeFilterLevel);
  return isMultipleAccountSelectorShown || isUserScopeInputShown;
};
